import {StsNotificationType} from './sts-notification-type';
export class StsNotification {
  level: StsNotificationType = StsNotificationType.Info;
  code: string;
  description: string;
}
